/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'src/components/Form/Form';
import { DateTimeRange } from 'src/components/DatetimeRangeInput/DateTimeRange';
import RangeInput from 'src/components/RangeInput/RangeInput';
import UniverseAware from 'src/utils/UniverseAware';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

@UniverseAware
class PaymentSearch extends Form {

    static propTypes = {
        ...Form.propTypes
    };

    static defaultProps = {
        ...Form.defaultProps
    };

    onTransactionTypeChange(e) {
        const data = this.props.data;

        if (e.target.value === 'deposit.withdrawal.bonus') {
            data.enabledTransactionTypes = ['deposit', 'withdrawal', 'bonus', 'reward' ];
        } else {
            data.enabledTransactionTypes = e.target.value.split('.');
        }

        this.setState({
            data
        });
    }

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { errors, bonusList, universePrefix } = this.props;

        const { enabledTransactionTypes } = this.props.data;

        const templateTransactionType = ['deposit', 'withdrawal', 'bonus', 'reward' ];


        const [ depositsEnabled, withdrawalsEnabled, bonusEnabled, rewardEnabled ] = templateTransactionType.map(v => {

            if (enabledTransactionTypes.length === templateTransactionType.length) {
                return true;
            }
            if (v === enabledTransactionTypes[0]) {
                return true;
            }

        });

        return (
            <div>
                <div className='payment-search-form'>
                    {
                        this.getField(
                            <DateTimeRange
                                dateFormat='yyyy-MM-dd'
                                timeFormat='HH:mm:ss'
                                { ...this.getFieldParameters('range') }
                            />
                        )
                    }
                    <div className='form-prefix-group'>
                        { universePrefix ? <span className='form-prefix-group__label'>{ universePrefix }</span> : null }
                        {
                            this.getField(
                                <input
                                    label='Account ID'
                                    { ...this.getFieldParameters('account-id') }
                                />
                            )
                        }
                    </div>
                    {
                        this.getField(
                            <select
                                label='Transaction Types'
                                { ...this.getFieldParameters('transaction-types') }
                                onChange={ this.onTransactionTypeChange.bind(this)}
                                value={ enabledTransactionTypes.join('.') }
                                data-test='payment-search-form-transaction-types-select'
                            >
                                <option value='deposit.withdrawal.bonus'>All</option>
                                <option value='deposit'>Deposit</option>
                                <option value='withdrawal'>Withdrawal</option>
                                <option value='bonus'>Bonus</option>
                            </select>
                        )
                    }
                    {
                        this.getField(
                            <RangeInput
                                prefix='£'
                                label='Amount'
                                { ...this.getFieldParameters('amount') }
                            />
                        )
                    }
                    <div>
                        <h4>Filters</h4>
                        <div className='row'>
                            <div className='col-3' data-test='payment-search-deposit'>
                                <h4>Deposit</h4>
                                { this.getCheckbox('deposit[initiated]', 'Initiated',
                                    'payment-search-deposit-initiated', !depositsEnabled) /* new + initiated */}
                                { this.getCheckbox('deposit[paid]', 'Paid',
                                    'payment-search-deposit-paid', !depositsEnabled) }
                                { this.getCheckbox('deposit[failed]', 'Failed',
                                    'payment-search-deposit-failed', !depositsEnabled)
                                }
                                { this.getCheckbox('deposit[cancelled]', 'Cancelled',
                                    'payment-search-deposit-rejected', !depositsEnabled)
                                }
                                { this.getCheckbox('deposit[internal-error]', 'Error',
                                    'payment-search-deposit-error', !depositsEnabled)
                                }
                            </div>
                            <div className='col-3' data-test='payment-search-withdrawal'>
                                <h4>Withdrawal</h4>
                                { this.getCheckbox('withdrawal[requested.assigned]', 'Requested',
                                    'payment-search-withdrawal-requested', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[initiated]', 'Initiated',
                                    'payment-search-withdrawal-initiated', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[paid]', 'Paid',
                                    'payment-search-withdrawal-paid', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[failed]', 'Failed',
                                    'payment-search-withdrawal-failed', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[cancelled]', 'Cancelled',
                                    'payment-search-withdrawal-canceled', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[rejected]', 'Rejected',
                                    'payment-search-withdrawal-rejected', !withdrawalsEnabled)
                                }
                                { this.getCheckbox('withdrawal[internal-error]', 'Error',
                                    'payment-search-withdrawal-error', !withdrawalsEnabled)
                                }
                            </div>
                            <div className='col-3' data-test='payment-search-adjustments'>
                                <h4>Adjustments</h4>
                                { this.getCheckbox('adjustment[bank-transfer]', 'Bank transfer') }
                                { this.getCheckbox('adjustment[cash]', 'Cash') }
                                { this.getCheckbox('adjustment[cheque]', 'Cheque') }
                                { this.getCheckbox('manual[trading]', 'Manual - Trading') }
                                { this.getCheckbox('manual[other]', 'Manual - Non-Trading') }
                                { this.getCheckbox('casino[casiono-bonus]', 'Casino') }
                            </div>
                            <div className='col-3' data-test='payment-search-bonuses'>
                                <h4>Bonuses</h4>
                                { bonusList.map(bonus => this.getCheckbox(`bonus[${bonus.get('type')}]`, bonus.get('name'), `bonuses-${bonus.get('type')}`, !bonusEnabled)) }
                            </div>
                            <div className='col-3' data-test='payment-search-provider'>
                                <h4>Payment Provider</h4>
                                { (this.props.usePaymentFormForUniverse.type === 'realex' || this.props.usePaymentFormForUniverse.type === 'multi-deposit') && this.getCheckbox('provider[realex]', 'Realex', 'payment-search-provider-realex') }
                                { (this.props.usePaymentFormForUniverse.type === 'paysafe' || this.props.usePaymentFormForUniverse.type === 'multi-deposit') && this.getCheckbox('provider[paysafe]', 'Paysafe', 'payment-search-provider-paysafe') }
                                { this.props.usePaymentFormForUniverse.openBanking === 'yaspa' && this.getCheckbox('provider[yaspa]', 'Yaspa', 'payment-search-provider-yaspa') }
                                { this.getCheckbox('provider[banktransfer]', 'Bank Transfer or Manual', 'payment-search-provider-banktransfer') }
                                { this.getCheckbox('provider[worldpay]', 'Worldpay', 'payment-search-provider-worldpay') }
                            </div>
                        </div>
                    </div>

                    { this.getBasicError(errors.get && errors.get('program')) }

                    <div className='row'>
                        <div className='col-2'>
                            { this.getCheckbox('summary', 'Include summary') }
                        </div>
                        <div className='col-2'>
                            { this.getCheckbox('save', 'Save report') }
                        </div>
                        <div className='col-3'>
                            <button data-test='payment-search-form-run-report-button' className='btn btn-primary' type='submit'>
                                Run Report
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const PaymentSearchForm = observer('PaymentSearch', (props) => {

    const common = useCommon();
    const config = ConfigState.get(common);
    const { usePaymentFormForUniverse } = config.config;
    const { data, bonusList, status, bonusStatus, onSubmit } = props;
    return (
        <PaymentSearch
            data={ data }
            bonusList={ bonusList }
            disabled={ status === 'IN_PROGRESS' || bonusStatus === 'IN_PROGRESS' }
            usePaymentFormForUniverse={ usePaymentFormForUniverse }
            onSubmit={ onSubmit } />
    );
});
